"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/render/VectorContext
 */

/**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */
var VectorContext =
/** @class */
function () {
  function VectorContext() {}
  /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   */


  VectorContext.prototype.drawCustom = function (geometry, feature, renderer, hitDetectionRenderer) {};
  /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */


  VectorContext.prototype.drawGeometry = function (geometry) {};
  /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */


  VectorContext.prototype.setStyle = function (style) {};
  /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   */


  VectorContext.prototype.drawCircle = function (circleGeometry, feature) {};
  /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   */


  VectorContext.prototype.drawFeature = function (feature, style) {};
  /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   */


  VectorContext.prototype.drawGeometryCollection = function (geometryCollectionGeometry, feature) {};
  /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawLineString = function (lineStringGeometry, feature) {};
  /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawMultiLineString = function (multiLineStringGeometry, feature) {};
  /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawMultiPoint = function (multiPointGeometry, feature) {};
  /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawMultiPolygon = function (multiPolygonGeometry, feature) {};
  /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawPoint = function (pointGeometry, feature) {};
  /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawPolygon = function (polygonGeometry, feature) {};
  /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */


  VectorContext.prototype.drawText = function (geometry, feature) {};
  /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */


  VectorContext.prototype.setFillStrokeStyle = function (fillStyle, strokeStyle) {};
  /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [opt_declutterImageWithText] Shared data for combined decluttering with a text style.
   */


  VectorContext.prototype.setImageStyle = function (imageStyle, opt_declutterImageWithText) {};
  /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [opt_declutterImageWithText] Shared data for combined decluttering with an image style.
   */


  VectorContext.prototype.setTextStyle = function (textStyle, opt_declutterImageWithText) {};

  return VectorContext;
}();

var _default = VectorContext;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7OztBQU1BO0FBQUE7QUFBQTtFQUFBLDBCQXNHQztFQXJHQzs7Ozs7Ozs7OztFQVFBQSwrQ0FBV0MsUUFBWCxFQUFxQkMsT0FBckIsRUFBOEJDLFFBQTlCLEVBQXdDQyxvQkFBeEMsRUFBNEQsQ0FBSSxDQUFoRTtFQUVBOzs7Ozs7O0VBS0FKLGlEQUFhQyxRQUFiLEVBQXFCLENBQUksQ0FBekI7RUFFQTs7Ozs7OztFQUtBRCw2Q0FBU0ssS0FBVCxFQUFjLENBQUksQ0FBbEI7RUFFQTs7Ozs7O0VBSUFMLCtDQUFXTSxjQUFYLEVBQTJCSixPQUEzQixFQUFrQyxDQUFJLENBQXRDO0VBRUE7Ozs7OztFQUlBRixnREFBWUUsT0FBWixFQUFxQkcsS0FBckIsRUFBMEIsQ0FBSSxDQUE5QjtFQUVBOzs7Ozs7RUFJQUwsMkRBQXVCTywwQkFBdkIsRUFBbURMLE9BQW5ELEVBQTBELENBQUksQ0FBOUQ7RUFFQTs7Ozs7O0VBSUFGLG1EQUFlUSxrQkFBZixFQUFtQ04sT0FBbkMsRUFBMEMsQ0FBSSxDQUE5QztFQUVBOzs7Ozs7RUFJQUYsd0RBQW9CUyx1QkFBcEIsRUFBNkNQLE9BQTdDLEVBQW9ELENBQUksQ0FBeEQ7RUFFQTs7Ozs7O0VBSUFGLG1EQUFlVSxrQkFBZixFQUFtQ1IsT0FBbkMsRUFBMEMsQ0FBSSxDQUE5QztFQUVBOzs7Ozs7RUFJQUYscURBQWlCVyxvQkFBakIsRUFBdUNULE9BQXZDLEVBQThDLENBQUksQ0FBbEQ7RUFFQTs7Ozs7O0VBSUFGLDhDQUFVWSxhQUFWLEVBQXlCVixPQUF6QixFQUFnQyxDQUFJLENBQXBDO0VBRUE7Ozs7OztFQUlBRixnREFBWWEsZUFBWixFQUE2QlgsT0FBN0IsRUFBb0MsQ0FBSSxDQUF4QztFQUVBOzs7Ozs7RUFJQUYsNkNBQVNDLFFBQVQsRUFBbUJDLE9BQW5CLEVBQTBCLENBQUksQ0FBOUI7RUFFQTs7Ozs7O0VBSUFGLHVEQUFtQmMsU0FBbkIsRUFBOEJDLFdBQTlCLEVBQXlDLENBQUksQ0FBN0M7RUFFQTs7Ozs7O0VBSUFmLGtEQUFjZ0IsVUFBZCxFQUEwQkMsMEJBQTFCLEVBQW9ELENBQUksQ0FBeEQ7RUFFQTs7Ozs7O0VBSUFqQixpREFBYWtCLFNBQWIsRUFBd0JELDBCQUF4QixFQUFrRCxDQUFJLENBQXREOztFQUNGO0FBQUMsQ0F0R0Q7O2VBd0dlakIsYSIsIm5hbWVzIjpbIlZlY3RvckNvbnRleHQiLCJnZW9tZXRyeSIsImZlYXR1cmUiLCJyZW5kZXJlciIsImhpdERldGVjdGlvblJlbmRlcmVyIiwic3R5bGUiLCJjaXJjbGVHZW9tZXRyeSIsImdlb21ldHJ5Q29sbGVjdGlvbkdlb21ldHJ5IiwibGluZVN0cmluZ0dlb21ldHJ5IiwibXVsdGlMaW5lU3RyaW5nR2VvbWV0cnkiLCJtdWx0aVBvaW50R2VvbWV0cnkiLCJtdWx0aVBvbHlnb25HZW9tZXRyeSIsInBvaW50R2VvbWV0cnkiLCJwb2x5Z29uR2VvbWV0cnkiLCJmaWxsU3R5bGUiLCJzdHJva2VTdHlsZSIsImltYWdlU3R5bGUiLCJvcHRfZGVjbHV0dGVySW1hZ2VXaXRoVGV4dCIsInRleHRTdHlsZSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcmVuZGVyL1ZlY3RvckNvbnRleHQuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=